import type { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'
import { Outlet } from 'react-router-dom'
import React from 'react'
import Layout from '../components/layout'

export const LayoutWithApolloProvider = ({ apolloClient }: { apolloClient: ApolloClient<NormalizedCacheObject> }) => {
  return (
    <ApolloProvider client={apolloClient}>
      <Layout>
        <Outlet />
      </Layout>
    </ApolloProvider>
  )
}
